<template>
  <header class="bg-white shadow-sm border-l border-b border-gray-200 sticky top-0 z-50 flex-shrink-0">
    <div class="flex items-center justify-between px-4 py-3">
      <!-- Left side -->
      <div class="flex items-center space-x-4">
        <!-- Menu button mobile -->
        <button 
          @click="$emit('toggle-mobile-menu')" 
          class="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors duration-200"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
        
        <!-- Breadcrumbs -->
        <Breadcrumbs :breadcrumbs="breadcrumbs" />
      </div>

      <!-- Center - Search Bar -->
      <SearchBar 
        v-model:search-query="searchQuery"
      />

      <!-- Right side -->
      <div class="flex items-center space-x-2 sm:space-x-4">
        <!-- Quick Actions Button -->
        <QuickActions 
          :is-open="showQuickActions"
          @toggle="$emit('toggle-quick-actions')"
          @action="$emit('quick-action', $event)"
        />

        <!-- Notifications -->
        <Notifications 
          :is-open="showNotifications"
          :notification-count="notificationCount"
          :notifications="notifications"
          @toggle="$emit('toggle-notifications')"
          @view-all="$emit('view-all-notifications')"
        />

        <!-- User Menu -->
        <UserMenu />
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Breadcrumbs from './Breadcrumbs.vue'
import SearchBar from './SearchBar.vue'
import QuickActions from './QuickActions.vue'
import Notifications from './Notifications.vue'
import UserMenu from '@/components/UserMenu.vue'

interface Breadcrumb {
  title: string
  to: string
}

interface Notification {
  id: string
  title: string
  message: string
  time: string
  type?: string
}

interface Props {
  breadcrumbs: Breadcrumb[]
  showQuickActions: boolean
  showNotifications: boolean
  notificationCount: number
  notifications: Notification[]
}

defineProps<Props>()

const searchQuery = ref('')

defineEmits<{
  'toggle-mobile-menu': []
  'toggle-quick-actions': []
  'toggle-notifications': []
  'quick-action': [action: string]
  'view-all-notifications': []
}>()
</script>
